import React, {useState} from 'react';
import "../styles/index.css"
import card_video from "../img/chai-background.mp4"

const Upcoming = () => {

	 // Step 1: Define a state variable for  events
	 const [events, setEvents] = useState([
        {
            title: "SWE x Pyaali Fundraiser",
            date: "March 25, 2025",
            time: "12pm - 3pm",
            location: "Illini Union - Main Quad",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3051.4946042093366!2d-88.22974682309786!3d40.108979771490766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880cd73fd25da33d%3A0x134ef3dfbe604ba!2sAnniversary%20Plaza!5e0!3m2!1sen!2sus!4v1742616415391!5m2!1sen!2sus"
        },
		{
            title: "Pyaali @ UIUC",
            date: "March 27, 2025",
            time: "Afternoon",
            location: "Bardeen Quad, UIUC",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1229.382117385897!2d-88.22791202422222!3d40.111461523691226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880cd740050bc371%3A0x36e61023843158a1!2sBardeen%20Quadrangle!5e0!3m2!1sen!2sus!4v1742616571881!5m2!1sen!2sus"
        },

		
		
    ]);
	return (

	<div>
		<div className="main-content">	
			<video autoPlay loop muted playsInline className="card-video">
				<source src={card_video} type="video/mp4" />
			</video>
				<div className="on-top">
				<h2 className="topic-heading">Upcoming Cart Days</h2>
				<ul className="event-list">
					{events.map((event, index) => (
						<li key={index}>
							<div className="upcoming-text">
								<strong>{event.title}</strong><br />
								Date: {event.date}<br />
								Time: {event.time}<br />
								Location: {event.location}<br />
							</div>
							
							<iframe
								className="maps-style"
								src={event.mapUrl}
								frameBorder="0"
			
								allowFullScreen
								aria-hidden="false"
								tabIndex="0"
								title={`Map for ${event.title}`}
							></iframe>
						</li>
					))}
				</ul>


				</div>
				
		</div>
	</div>
	);
};

export default Upcoming;
